import { defineStore } from "pinia"

export const useDrawerStore = defineStore("drawerStore", {
  state: () => ({
    drawerMobileOpen: false,
    drawerDesktopOpen: true,
    sidebarOpen: false,
  }),

  actions: {
    openMobileDrawer() {
      this.drawerMobileOpen = true
    },
    closeMobileDrawer() {
      this.drawerMobileOpen = false
    },
    toggleMobileDrawer() {
      this.drawerMobileOpen = !this.drawerMobileOpen
    },
    openDesktopDrawer() {
      this.drawerDesktopOpen = true
    },
    closeDesktopDrawer() {
      this.drawerDesktopOpen = false
    },
    toggleDesktopDrawer() {
      this.drawerDesktopOpen = !this.drawerDesktopOpen
    },
    openContentMenu() {
      this.sidebarOpen = true
    },
    closeContentMenu() {
      this.sidebarOpen = false
    },
    toggleContentMenu() {
      this.sidebarOpen = !this.sidebarOpen
    },
  },
})
